import createIcon from '../../createIcon';

/**
 * @component @name SettingsBrightness
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM0gzQzEuOSAzIDEgMy45IDEgNVYxOUMxIDIwLjEgMS45IDIxIDMgMjFIMjFDMjIuMSAyMSAyMyAyMC4xIDIzIDE5VjVDMjMgMy45IDIyLjEgMyAyMSAzWk0yMSAxOS4wMUgzVjQuOTlIMjFWMTkuMDFaTTggMTZIMTAuNUwxMiAxNy41TDEzLjUgMTZIMTZWMTMuNUwxNy41IDEyTDE2IDEwLjVWOEgxMy41TDEyIDYuNUwxMC41IDhIOFYxMC41TDYuNSAxMkw4IDEzLjVWMTZaTTEyIDlDMTMuNjYgOSAxNSAxMC4zNCAxNSAxMkMxNSAxMy42NiAxMy42NiAxNSAxMiAxNVY5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsBrightness = createIcon('SettingsBrightness', [
  [
    'path',
    {
      d: 'M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.99H21V19.01ZM8 16H10.5L12 17.5L13.5 16H16V13.5L17.5 12L16 10.5V8H13.5L12 6.5L10.5 8H8V10.5L6.5 12L8 13.5V16ZM12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15V9Z',
      key: '1uhafu',
    },
  ],
]);

export default SettingsBrightness;
